import React from "react";
import { Box } from "@mui/material";
import { COLORS, SIZES, DetailHeaderCell } from "../SkillSheetMainSectionUi";
import { FONT_SIZE } from "../../../../constants/fontSizes";

/**
 * 成果／アピールポイント
 */
export default function SkillSheetMainAchievement({ displayValues }) {
  const achievement = displayValues?.achievement?.trim();
  return (
    <Box
      sx={{
        border: `1px solid ${COLORS.border}`,
        borderRadius: `${SIZES.radius}px`,
        overflow: "hidden",
        backgroundColor: COLORS.valueBg,
      }}
    >
      {/* ヘッダー */}
      <Box
        sx={{
          display: "grid",
          borderBottom: `1px solid ${COLORS.border}`,
        }}
      >
        <DetailHeaderCell>成果/アピールポイント</DetailHeaderCell>
      </Box>

      {/* 成果 */}
      <Box
        sx={{
          fontSize: FONT_SIZE.XXS,
          lineHeight: 1.7,
          whiteSpace: "pre-wrap",
          p: 0.5,
        }}
      >
        {achievement ? achievement : "-"}
      </Box>
    </Box>
  );
}
